import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
let PerformanceListCountMixin = class PerformanceListCountMixin extends Vue {
    exists(count) {
        return count > 0;
    }
};
PerformanceListCountMixin = __decorate([
    Component
], PerformanceListCountMixin);
export default PerformanceListCountMixin;
